import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { ExecuteEntityType } from "../ea.enums";

const base = "background";
const background = createEndpointBase(base);

export const backgroundEndpoints = {
  backgroundExecute: background({
    method: "POST",
    path: "executeAsync",
    request: z.object({
      id: z.union([z.coerce.number(), z.array(z.coerce.number())]),
      type: z.nativeEnum(ExecuteEntityType),
    }),
    response: z.any(),
    description: "Starts an execution (script, job, or project) in the background.",
  }),
  backgroundStatus: background({
    method: "GET",
    path: "executeAsyncStatus",
    request: z.object({ backgroundExecutionId: z.string() }),
    response: z.any(),
    description: "Retrieves the status and report data for a background execution.",
  }),
  backgroundTestCases: background({
    method: "POST",
    path: "testCaseMap",
    request: z.any(),
    response: z.any(),
    description: "Maps Azure DevOps test case IDs to internal script IDs.",
  }),
  backgroundCandidates: background({
    method: "GET",
    path: "candidates",
    request: z.object({ type: z.nativeEnum(ExecuteEntityType) }),
    response: z.any(),
    description:
      "Retrieves list of entities (scripts, jobs, projects) available for background execution.",
  }),
} as const;
